export default __webpack_public_path__ + "static/media/v2.f1ce6c4d.jpg";